/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 案件資料功能頁面
 * @module CaseContainer
 */

import React from 'react';
// ----- import from local libraries -----
import {AlertModal} from 'web/components/modal/AlertModal';
// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
import Sidebar from '../../features/main-frame/components/Sidebar';
import ListPage from './components/ListPage';
import {useAlertModal} from 'web/components/modal/hooks/useAlertModal';
// ----- constants and enums -----

const Container = (props) => {
  const {
    alertRef,
    actionMode,
    alertMessage,
  } = useAlertModal();

  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <ListPage
            {...props}
            onDispatchList={() => {
              toggleDispatchListModal(true);
            }}
          />
        </div>
        <Footer />
      </div>

      <AlertModal
        ref={alertRef}
        mode={actionMode}
        message={alertMessage}
        onConfirm={() => onConfirm()}
        onCancel={() => {
          setNeedDispatchListLoad(true);
        }}
      />
    </>
  );
};

export default Container;
